export default "__VITE_ASSET__b9233fb6__"